import DonateForm from '@/components/user/DonateForm';
import user from '@/api/user';

const persistKey = 'donate-modal-shown';

function updateDonateModal(value) {
    user.updateDonateModal(
        this,
        value,
        () => {},
        error => {
            console.error('could not update donate modal doNotShowAgain state', error);
        },
        () => {},
    );
}

function getDonateUrl() {
    if( typeof window.kgkConfig === 'undefined' || typeof window.kgkConfig.donateUrl === 'undefined' ) {
        return 'https://www.krebsgesellschaftnrw.de/jetzt-spenden'; // fallback
    }

    return window.kgkConfig.donateUrl;
}

export default {
    openDonateModalIfNeeded(vueModal, userDetails) {
        
        if( typeof userDetails.prevent_donate_modal !== 'undefined' && userDetails.prevent_donate_modal ) {
            return;
        }

        if( sessionStorage.getItem(persistKey) === '1' ) {
            return;
        }

        let doNotShowAgainValue = false;

        /*const modalCloseTrigger = {
            trigger: 0
        };*/

        const closeHandler = function() {
            if( doNotShowAgainValue ) {
                updateDonateModal(true);
            }
            vueModal.hide('dialog');
            sessionStorage.setItem(persistKey, '1');
        };

        vueModal.show('dialog', {
            title: 'Kilometergeld spenden',
            component: DonateForm,
            props: {
                insideModal: true,
                //modalCloseTrigger: modalCloseTrigger,
            },
            on: {
                change(value) {
                    console.log('on change: ', value);
                    doNotShowAgainValue = !!value;
                },
            },
            buttons: [
                {
                    title: 'Nein',
                    default: true,
                    handler: closeHandler,
                },
                {
                    title: 'Ja, zum Formular',
                    handler() {
                        closeHandler();

                        Object.assign(document.createElement('a'), {
                            target: '_blank',
                            href: getDonateUrl(),
                        }).click();
                    },
                }
            ]
        });
    },
};
